import { onDeactivated, ref, toValue, type MaybeRef } from 'vue';
import TimePolicyPopup from '../components/TimePolicyPopup.vue';
import { useMouse } from '@vueuse/core';

export const useTimePolicyPopup = (disabled: MaybeRef<boolean>) => {
  const timeControllerRef = ref<HTMLDivElement | null>(null);
  const timePolicyRef = ref<InstanceType<typeof TimePolicyPopup> | null>(null);

  const { x: coordinateX } = useMouse();

  const showTimePolicy = () => {
    if (toValue(disabled)) {
      return;
    }
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    if (timePolicyRef.value?.$el && timeControllerRef.value) {
      timePolicyRef.value.$el.style.display = 'block';

      const { width: timePolicyWidth, height: timePolicyHeight } =
        timePolicyRef.value.$el.getBoundingClientRect();

      const { top: timeControllerTop, height: timeControllerHeight } =
        timeControllerRef.value.getBoundingClientRect();

      let top = 20 + timeControllerTop + timeControllerHeight;
      let left = 10 + coordinateX.value;

      if (top + timePolicyHeight > windowHeight) {
        top = timeControllerTop - timePolicyHeight - 20;
      }
      if (left + timePolicyWidth > windowWidth) {
        left = windowWidth - timePolicyWidth - 10;
      }

      timePolicyRef.value.$el.style.top = `${top}px`;
      timePolicyRef.value.$el.style.left = `${left}px`;
    }
  };

  const hideTimePolicy = () => {
    if (timePolicyRef.value) {
      timePolicyRef.value.$el.style.display = 'none';
    }
  };

  const isDropdownOpen = () => {
    return timeControllerRef.value?.querySelector('.open-dropdown') !== null;
  };

  const checkAndShowPolicy = () => {
    if (!toValue(disabled) && !isDropdownOpen()) {
      showTimePolicy();
    }
  };

  onDeactivated(() => {
    hideTimePolicy();
  });

  return {
    timeControllerRef,
    timePolicyRef,
    hideTimePolicy,
    checkAndShowPolicy,
  };
};
